<template>
    <article>
        <ContentHero
            :pending="pending"
            :image-position="entry?.contentHero?.[0]?.imagePosition || 'center'"
            :image="entry?.contentHero?.[0]?.image[0]"
            :background-color="entry?.contentHero?.[0]?.backgroundColor"
        >
            <template #title>{{ entry?.title }}</template>
            <template #description>{{ entry?.contentHero?.[0]?.description }}</template>
            <template #caption>{{ entry?.contentHero?.[0]?.caption }}</template>
        </ContentHero>

        <template v-if="pending">
            <PropertyList
                v-for="i in [1,2,3]"
                :key="i"
                :pending="true"
                :fixed-filter="i"
            />
        </template>

        <template v-else>
            <PropertyList
                v-for="(city, index) in response.data?.value?.cities"
                :key="index"
                :fixed-filter="city.id"
            >
                <template
                    v-if="city.title"
                    #title
                >
                    {{ city.title }}
                </template>

                <template
                    v-if="city.description"
                    #intro
                >
                    {{ city.description }}
                </template>
            </PropertyList>
        </template>

        <ClientOnly>
            <LazyMapBlock
                v-if="entry?.mapBlock?.[0]?.markers || pending"
                :markers="entry?.mapBlock?.[0]?.markers"
            >
                <template
                    v-if="entry?.mapBlock?.[0]?.description"
                    #description
                >
                    {{ entry.mapBlock[0].description }}
                </template>
            </LazyMapBlock>
        </ClientOnly>

        <RelatedItems
            :background-color="entry?.relatedItems?.[0]?.backgroundColor"
            :items="entry?.relatedItems?.[0]?.entries"
            :pending="pending"
        >
            <template
                v-if="entry?.relatedItems?.[0]?.title"
                #title
            >
                {{ entry.relatedItems[0].title }}
            </template>

            <template
                v-if="entry?.relatedItems?.[0]?.caption"
                #caption
            >
                {{ entry.relatedItems[0].caption }}
            </template>
        </RelatedItems>
    </article>
</template>

<script setup>
import locationsQuery from '~/graphql/queries/locationsPage.graphql';

const { variables } = useCraftGraphql();
delete variables.uri;
const response = await useLazyAsyncQuery({
    query: locationsQuery,
    variables
});
const pending = response.pending;
const { craftEntry: entry } = useCraftPage(response);
</script>
